// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
var url = window.location.href;
var arr = url.split("/");
export const server_ip = arr[0] + "//" + arr[2]+"/ybl-console";

//export const server_ip= "http://localhost:8443";

export const environment = {
  production: false,
  // firebase: {
  //   authDomain: "placementportal-e2768.firebaseapp.com",
  //   databaseURL: "https://placementportal-e2768.firebaseio.com",
  //   projectId: "placementportal-e2768",
  //   storageBucket: "placementportal-e2768.appspot.com",
  //   messagingSenderId: "314375698484",
  //   appId: "1:314375698484:web:8acea2c7140c0fe489f261",
  //   measurementId: "G-SS818FXN7X"
  // },
  organisations: server_ip + "/organisations",
  getCustomerList: server_ip + "/customerIds",
  getProfileList(page, size, approvalStatus) {
    return server_ip + "/profileList?approvalStatus=" + approvalStatus + "&page=" + page + "&size=" + size
  },
  getServicelist: server_ip + "/services",
  getServiceByEsbOrg: server_ip + "/getServiceByEsbOrgs",
  getEsbOrgFromOrgId(orgId) {
    return server_ip + "/getEsbOrgByConsoleOrg?orgId=" + orgId
  },

  getEsbOrgFromOrgIdForProfile(orgId,serviceId) {
    return server_ip + "/getEsbOrgByConsoleOrgandServiceId?orgId=" + orgId +"&ServiceId=" + serviceId
  },

  getServicesFromOrgId(orgId) {
    return server_ip + "/getServicesByConsoleOrg?orgId=" + orgId
  },
  getAlertList(page, size, isDownload) {
    return server_ip + "/alertList?page=" + page + "&size=" + size + "&isDownload=" + isDownload
  },
  getActiveAlertList: server_ip + "/activeAlertDashboard",
  getFutureAlertList: server_ip + "/futureAlertDashboard",
  getInActiveAlertList: server_ip + "/inactiveAlertDashboard",
  getAlertListDownload: server_ip + "/alertListDownload",

  getServiceRequestsByCustomerId: server_ip + "/getCasesForCustomers"

  //getBillDesk : `${server_ip}/getBillDeskReport`
};

// export const server_ip="http://192.168.1.8:8084";
// export const server_ip="http://192.168.29.232:8084";
// export const server_ip="http://localhost:8443";
// export const server_ip="https://10.82.128.101:8443";
//export const server_ip="";


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
